import { Unit } from "./TaxonomyElement";
import { ProductProperty } from "./ProductProperty";
import { ProductProp } from "../../models/ProductProp";
import { removeDuplicates } from "../../ProductsSearch/reducers/ProductsSearchRdc";

export type OrderSheetData = {
    id: number,
    name: string,
    items: OrderSheetItemData[],
    modified: Date,
    filterCategory: string,
    image: string
}


export class OrderSheetItemData {
    public catalogueProductId: string
    public quantity: number | null
    public unit: Unit
    public availableUnits: Unit[]
    public availableProperties: ProductProperty[]
    public selectedProperties: ProductProperty[]
    public properties: ProductProperty[]
    public name: string
    public image: string

    constructor(catalogueProductId: string,
        quantity: number | null,
        unit: Unit,
        availableUnits: Unit[],
        availableProperties: ProductProperty[],
        selectedProperties: ProductProperty[],
        properties: ProductProperty[],
        name: string,
        image: string) {
        this.catalogueProductId = catalogueProductId
        this.quantity = quantity
        this.unit = unit
        this.availableUnits = availableUnits
        this.availableProperties = availableProperties
        this.selectedProperties = selectedProperties
        this.properties = properties
        this.name = name
        this.image = image
    }

    static getSignature = (osid: OrderSheetItemData): string => {
        if (osid.selectedProperties && osid.selectedProperties.length > 0)
            return osid.catalogueProductId + ',' + removeDuplicates(osid.selectedProperties.flatMap(sp => sp.options).map(o => o.id)).sort().join(',')
        else
            return osid.catalogueProductId
    }
}